<template>
  <div class="list-consultings-client">
    <navigator :items="items"></navigator>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="container-fluid">
              <div class="row">
                <div class="col-12">
                  <div class="title-section">Minhas Dúvidas</div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <b-table stacked :items="data" hover :fields="fields" @row-clicked="selectItemTable">
                    <template v-slot:cell(created_at)="data">{{formatDate(data.value)}}</template>
                    <template v-slot:cell(question)="data">{{ limitText(data.value) }}</template>
                  </b-table>
                  <div class="no-data" v-if="data.length == 0">
                    <span>Você não tem dúvidas formuladas</span>
                  </div>
                  <b-pagination
                    class="float-right"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    aria-controls="my-table"
                  ></b-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/api/axios";
import { bus } from "@/main";
import helper from "@/imports/Helpers";
import moment from "moment";

export default {
  name: "list-consultings-client",
  data() {
    return {
      user_id: 0,
      client: {},
      perPage: 2,
      currentPage: 1,
      rows: 0,
      data: [],
      items: [
        {
          text: "Área do cliente",
          route: "client.dashboard"
        },
        {
          text: "Minhas Dúvidas",
          active: true
        },
        {
          text: "Nova Dúvida",
          route: "client.consulting"
        }
      ],
      fields: [
        { key: "id", label: "ID Do atendimento" },
        { key: "subject", label: "Assunto" },
        { key: "question", label: "Dúvida" },
        { key: "status", label: "Situação" },
        { key: "created_at", label: "Data do pedido" }
      ]
    };
  },
  mounted() {
    bus.$emit('changeLoading', true);
    this.user_id = localStorage.getItem("auth.user_id");

    helper.getClientUserPermissions().then(data => {
      this.client = data;
      if (!helper.clientCanAccessItem(this.client, "Consultoria")) {
        bus.$emit('changeLoading', false);
        this.$router.push({ name: "Home" });
      }
      this.providerData();
    });
  },
  watch: {
    currentPage: {
      handler: function(value) {
        this.providerData();
      }
    }
  },
  methods: {
    providerData: function() {
      let promise = axios
        .get(
          `${process.env.VUE_APP_API_HOST}/api/consultings?filter[user_id]=${
            this.user_id
          }&${this.urlBuild()}`
        )
        .then(response => {
          bus.$emit('changeLoading', false);
          this.rows = response.data.total;
          this.data = response.data.data;
        })
        .catch( error => {
          bus.$emit('changeLoading', false);
        });
    },
    urlBuild: function() {
      let url =
        "sort=created_at&page[number]=" + this.currentPage + "&page[size]=" + this.perPage;
      return url;
    },
    formatDate: function(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    limitText: function(text) {
      return helper.limitText(text, 185);
    },
    selectItemTable: function(record, index) {
      this.$router.push({ name: "client.consulting", params: { id: record.id } });
    },
  }
};
</script>

<style lang="scss">
@import "@/styles/General.scss";
.list-consultings-client {
  .table.b-table.b-table-stacked > tbody > tr > [data-label]::before {
    width: 25%;
  }
  .table.b-table.b-table-stacked > tbody > tr > [data-label] > div {
    width: calc(100% - 25%);
  }
}
</style>